


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const recoredFilePaymentReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.FILE_RECORD_PAYMENT:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.FILE_RECORD_PAYMENT_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.FILE_RECORD_PAYMENT_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
